import { HTTP_TOKEN } from "./http";

export const getCustomConversions = (params) => {
  return HTTP_TOKEN.get("custom-conversion", { params }).then((result) => {
    return result.data;
  });
};

export const getCustomConversion = (customCId) => {
  return HTTP_TOKEN.get(`custom-conversion/${customCId}`).then((result) => {
    return result.data;
  });
};

export const createCustomConversion = (data) => {
  return HTTP_TOKEN.post("custom-conversion", data).then((result) => {
    return result.data;
  });
};

export const updateCustomConversion = (customCId, params) => {
  return HTTP_TOKEN.put(`custom-conversion/${customCId}`, { params }).then((result) => {
    return result.data;
  });
};

export const deleteCustomConversion = (customCId) => {
  return HTTP_TOKEN.delete(`custom-conversion/${customCId}`, {}).then((result) => {
    return result.data;
  });
};

// actives
export const getCustomConversionActives = (customId, params) => {
  return HTTP_TOKEN.get(`custom-conversion/${customId}/action`, { params }).then((result) => {
    return result.data;
  });
};

export const getCustomConversionActive = (customId, actionId) => {
  return HTTP_TOKEN.get(`custom-conversion/${customId}/action/${actionId}`).then((result) => {
    return result.data;
  });
};

export const createCustomConversionActive = (customId, data) => {
  return HTTP_TOKEN.post(`custom-conversion/${customId}/action`, data).then((result) => {
    return result.data;
  });
};

export const updateCustomConversionActive = (customId, actionId, data) => {
  return HTTP_TOKEN.put(`custom-conversion/${customId}/action/${actionId}`, data).then((result) => {
    return result.data;
  });
};

export const deleteCustomConversionActive = (customId, actionId) => {
  return HTTP_TOKEN.delete(`custom-conversion/${customId}/action/${actionId}`, {}).then((result) => {
    return result.data;
  });
};